export default "__VITE_ASSET__Do1SO8rX__"